import "swiper/css";

import { getConfig } from "@src/config";
import useDisplayName from "@src/shared/context/displayname/useDisplayName";
import useSearchFilter from "@src/shared/context/searchfilter/useSearchFilter";
import useSearchResult from "@src/shared/context/searchresult/useSearchResult";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";

import {
    CardContainer,
    DesktopContainer,
    HeadlineContainer,
    HeadlineText,
    HorizontalLine,
    MobileContainer,
    Root,
    SwiperSlider,
} from "./LatestOffers.sc";
import { VehicleCard } from "./VehicleCard";

SwiperCore.use([Pagination]);

export const LatestOffers: React.FunctionComponent = () => {
    const { filter } = useSearchFilter();
    const { getDisplayName } = useDisplayName();

    const searchResult = useSearchResult();
    const vehicles = searchResult.vehicles?.slice(0, 4);

    const disclaimer = getConfig("scope").domain === "car4me.porschefinance.hu" && (
        <DisclaimerTextWrapper>
            <FormattedMessage
                id="leaseme.disclaimerText"
                defaultMessage="Tájékoztató az üzemanyag-fogyasztásról és a szén-dioxid-kibocsátásról: a megadott értékeket a 715/2007/EK európai parlamenti és tanácsi rendelet (mindenkori érvényes szövegváltozata) által előírt mérési módszer szerint mérték. 2017. szeptember 1-jétől bizonyos új járművek típusjóváhagyása a Könnyűgépjárművekre Vonatkozó, Világszinten Harmonizált Vizsgálati Eljárás (Worldwide Harmonized Light Vehicle Test Procedure, WLTP) alapján történik, amely egy új, reálisabb vizsgálati eljárás az üzemanyag-fogyasztás és a CO2-kibocsátás mérésére. Az új személygépjárművek esetében 2018. szeptember 1-jétől, míg a haszongépjárművek esetében 2019. szeptember 1-jétől az NEDC-t teljes mértékben felváltja egy új vizsgálati eljárás, a WLTP (Woldwide Harmonized Light Vehicle Test Procedure). A reálisabb vizsgálati körülmények miatt a WLTP keretében mért üzemanyag-fogyasztás és CO2-kibocsátás sok esetben magasabb az NEDC-ben mért értékeknél. Az értékek nem egyes gépjárművekre vonatkoznak, nem részei az ajánlatnak, hanem a különböző járműtípusok összehasonlítására szolgálnak. Egy gépjármű üzemanyag-fogyasztását és a CO2-kibocsátását a vezetői szokások és egyéb, nem technikai jellegű tényezők (pl. környezeti feltételek) is befolyásolják. Különösen az extrafelszereltségek és a tartozékok (pl. szélesebb gumiabroncsok, klímaberendezés, tetőcsomagtartó) megváltoztatják a gépjármű releváns jellemzőit, mint amilyen például a tömeg, a gördülési ellenállás valamint az aerodinamika, és ezáltal eltérést eredményeznek a konfigurált modell adataiban. Az üzemanyag-fogyasztásra és a CO2-kibocsátásra vonatkozó adatok a kiválasztott gumiabroncs formától és az optimális extrafelszereltségektől függő tartomány adatai mellett érvényesek. Az új személygépkocsi fajlagos üzemanyag-fogyasztási és széndioxid-kibocsátási adatai megtalálhatóak az üzemanyag-gazdaságossági ismertetőben, amely ingyenesen hozzáférhető minden értékesítési helyen és a fogyasztóvédelmi hatóságnál.{br}{br}KÉRJÜK, TARTSA SZEM ELŐTT, HOGY EZ AZ ÁRLISTA A PORSCHE HUNGARIA KFT. ÁLTAL A MAGYARORSZÁGI VOLKSWAGEN MÁRKAKERESKEDÉSEK SZÁMÁRA KIBOCSÁTOTT, NEM KÖTELEZŐ ÉRVÉNNYEL AJÁNLOTT ÁRAKAT TÜNTETI FEL, ÉS CSUPÁN AZ ÖN ELŐZETES TÁJÉKOZÓDÁSÁT SZOLGÁLJA! A feltüntetett adatok (beleértve az árakat is) nem minősülnek kötelező érvényű ajánlatnak. A meghirdetett árak euróban értendőek, tartalmazzák a 27 %-os ÁFÁ-t (kivéve ott, ahol kifejezetten szerepel, hogy “nettó”), de NEM TARTALMAZZÁK A REGISZTRÁCIÓS ADÓT. Az üzembe- és forgalombahelyezés költsége külön fizetendő. Az árak márkakereskedőnként eltérhetnek. A tájékoztatóink folyamatos aktualizálása ellenére előfordulhat, hogy a megjelenített adatok már nem aktuálisak, vagy elírást tartalmaznak, mindezért nem áll módunkban felelősséget vállalni. A modellvariánsok, konstrukciók, felszereltségek, technikai adatok, árak, feltétel maszkok és az egyéb közölt adatok - előzetes értesítés nélkül történő - változtatásának jogát a Porsche Hungaria Kft. fenntartja. A tájékoztatás nem teljeskörű. KÉRJÜK, VEGYE FEL A KAPCSOLATOT AZ ÖN VOLKSWAGEN MÁRKAKERESKEDŐJÉVEL ANNAK ÉRDEKÉBEN, HOGY MEGKAPJA TŐLE A TÉNYLEGES ÉS TELJESKÖRŰ AJÁNLATÁT, VALAMINT A VÉTELÁR MEGHATÁROZÁSÁRÓL ÉS MEGFIZETÉSÉRŐL SZÓLÓ TÁJÉKOZTATÁST.{br}{br}* A feltüntetett lízingdíjak tájékoztató jellegűek, a Porsche Finance Zrt. részéről semmilyen kötelezettségvállalást nem jelentenek. A feltüntetett lízingdíjak nyíltvégű pénzügyi lízingfinanszírozásra vonatkoznak, az általános forgalmi adó összegét tartalmazzák és az adott gépjármű típus ajánlott, a honlapon feltüntetett árfolyamon átszámított kiskereskedelmi ár (bruttó) mellett kerültek meghatározásra. A Finanszírozó a belső szabályzataiban rögzítettek szerint elvégzett ügylet- és ügyfélminősítés eredményétől függően vállalja a gépjármű finanszírozását, és határozza meg a kockázatvállalás végleges feltételeit, melynek keretében a finanszírozási feltételek módosulhatnak illetve akár egyéb fedezetet írhat elő. A kamatozás fix, a kamatláb mértéke nem változik a futamidő alatt. A teljeskörű kárbiztosítás (CASCO biztosítás) megkötése és fenntartása a szerződés hatálya alatt kötelező, melynek költsége a Lízingbevevőt terheli! Felhívjuk a figyelmét, hogy a tájékoztatás nem teljes körű, további részleteket a Porsche Finance Zrt. Általános Üzletszabályzata, Pénzügyi Lízingügyletek Üzletszabályzata és Hirdetményei tartalmazzák, melyek letölthetőek a *www.porschefinance.hu oldalról, vagy az Ügyfélszolgálatunkon valamint a Közvetítőnél elérhetőek. A nyíltvégű pénzügyi lízing finanszírozást kizárólag fogyasztónak nem minősülő személyek vehetik igénybe. A Porsche Hungária Kft. a finanszírozás közvetítőjeként a Porsche Finance Zrt. képviseletében jár el.{br}{br}A konfigurálás közben kiválasztott opcionális felszereltségek módosítják a gépjármű vételárát, ennek következtében a finanszírozási ajánlatban illetve a casco tájékoztatóban feltüntetett havi díjak értéke is változik."
                values={{ br: <br /> }}
            />
        </DisclaimerTextWrapper>
    );

    if (getConfig("scope").domain === "car4me.porschefinance.hu" && filter.financeType === "closedEndLeasing") {
        return null;
    }

    return vehicles?.length && vehicles.length > 0 ? (
        <Root>
            <HeadlineContainer>
                <HorizontalLine />
                <HeadlineText>
                    <FormattedMessage
                        id="leaseme.latestOffers.title"
                        defaultMessage="Neue {financeType}-Angebote"
                        values={{
                            financeType: getDisplayName("financeType", filter.financeType),
                        }}
                    />
                </HeadlineText>
            </HeadlineContainer>

            <DesktopContainer>
                <CardContainer itemCount={vehicles?.length}>
                    {vehicles?.map((vehicle, idx) => (
                        <VehicleCard key={vehicle.vehicleId!} vehicle={vehicle} priceInfoAlignment={idx === 0 ? "left" : "right"} />
                    ))}
                </CardContainer>
                {disclaimer}
            </DesktopContainer>

            <MobileContainer>
                {vehicles?.length && vehicles.length > 2 ? (
                    <SwiperSlider
                        spaceBetween={30}
                        slidesPerView={"auto"}
                        loop={true}
                        pagination={{ clickable: true }}
                        shortSwipes={false}
                        longSwipesMs={100}
                        longSwipesRatio={0.1}
                        allowTouchMove={true}
                        breakpoints={{
                            768: {
                                spaceBetween: 40,
                            },
                        }}
                    >
                        {vehicles?.map((vehicle) => (
                            <SwiperSlide key={vehicle.vehicleId!} style={{ maxWidth: "320px" }}>
                                <VehicleCard vehicle={vehicle} />
                            </SwiperSlide>
                        ))}
                    </SwiperSlider>
                ) : (
                    <CardContainer itemCount={vehicles?.length}>
                        {vehicles?.map((vehicle, idx) => (
                            <VehicleCard key={vehicle.vehicleId!} vehicle={vehicle} priceInfoAlignment={idx === 0 ? "left" : "right"} />
                        ))}
                    </CardContainer>
                )}
                {disclaimer}
            </MobileContainer>
        </Root>
    ) : null;
};

const DisclaimerTextWrapper = styled.div`
    margin-top: 40px;
`;
